import type { ComponentProps, JSX } from "react";
import { createContext, useContext } from "react";
import { Button } from "@/components/ui/button";
import { V3Button } from "@/components/ui/v3/button";

// The transcript's pieces (recordings, audio, speaker chips, the editor) in
// the v3.2 look when they sit in the v3.2 transcript drawer; the classic
// workspace keeps its styles.
export const TranscriptV3Context = createContext(false);
export const useTranscriptV3 = (): boolean => useContext(TranscriptV3Context);

const V3_VARIANT: Record<
  string,
  "primary" | "secondary" | "ghost" | "destructive"
> = {
  default: "primary",
  outline: "secondary",
  secondary: "secondary",
  ghost: "ghost",
  destructive: "destructive",
  link: "ghost",
};

// A Button that becomes a v3.2 pill inside the v3.2 transcript drawer.
export const TranscriptButton = ({
  variant = "default",
  size: _size,
  ...props
}: ComponentProps<typeof Button>): JSX.Element => {
  const v3 = useTranscriptV3();
  if (!v3) return <Button size={_size} variant={variant} {...props} />;
  return (
    <V3Button
      variant={V3_VARIANT[variant ?? "default"] ?? "secondary"}
      {...props}
    />
  );
};
